import { queryFunctionGetEntityServerDriven } from './queryFunctionGetEntityServerDriven';
import { queryFunctionGetEntity } from './queryFunctionGetEntity';
/**
 * Creates a query function for the useODatReadInfiniteApi hook.
 */
export const makeQueryFn = (oDataQuery, pageLength, endpointName, uniqueIdentifier) => ctx => {
    const { pageParam } = ctx;
    if (pageLength !== undefined) {
        return queryFunctionGetEntity({
            oDataQuery,
            pageLength,
            endpointName,
            uniqueIdentifier,
        });
    }
    if (typeof pageParam === 'string') {
        // Handle nextLink from server-driven paging
        return queryFunctionGetEntityServerDriven({ nextLink: pageParam });
    }
    return queryFunctionGetEntity({
        oDataQuery,
        endpointName,
        uniqueIdentifier,
    });
};
